module.exports = __webpack_public_path__ + "img/review-5.beb32098.png";